<div class="main-wrapper">
    <div class="app flex-row align-items-center text-white error-component">
        <div class="container">
            <div class="row justify-content-center vertical-center">
                <div class="col-md-6">
                    <div class="clearfix text-center">
                        <img src="assets/images/errors/error-404.svg" style="max-height: 300px;">
                        <h1 class="pt-4">Oops! You're lost.</h1>
                        <p class="text-muted mb-4">The page you are looking for was not found.</p>
                        <a routerLink="/" class="btn btn-primary">Home</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>